import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2 .01 7Z",
  fill: "currentColor"
}));
export default SvgSend;